export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/work_tags')
    },

    async add(form) {
        return await $axios.post('/work_tags', form)
    },

    async update(tag_id, form) {
        return await $axios.put(`/work_tags/${tag_id}`, form)
    },

    async remove(tag_id) {
        return await $axios.delete(`/work_tags/${tag_id}`)
    },

    async requestForDelete(tag_id) {
        return await $axios.post(`/work_tags/${tag_id}/markToRemove`)
    },
})
